import { createSlice } from '@reduxjs/toolkit'

export const mailBox = createSlice({
    name: 'mailItem',
    initialState: {
        config: null,
        labels: null,
        label: 'inbox',
        mailItemOpen: false,
        mailID: 0,
        reload: 0,
        moveId: 0,
    },
    reducers: {
        setConfig: (state, {payload}) => {
            state.config = payload.config;
        },
        mailItem: (state, {payload}) => {
            state.mailID = payload.id;
            state.mailItemOpen = payload.open;
        },
        setLabels: (state, {payload}) => {
            state.labels = payload.labels;
        },
        setLabel: (state, {payload}) => {
            state.label = payload.label;
        },
        reloadMails: (state, action) => {
            state.reload += action.payload
        },
        setMoveId: (state, action) => {
            state.moveId += action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    setMoveId,
    reloadMails ,
    mailItem,
    setLabels,
    setLabel,
    setConfig
} = mailBox.actions

export default mailBox.reducer